import { Injectable, signal } from '@angular/core';
import { ReportDefinition } from '../models/report.model';

/**
 * Holds the current ad-hoc (unsaved) report definition so the builder can hand
 * it to the results view across a route change without persistence.
 *
 * Phase 1 uses this for run-and-view. Phase 2 adds saved reports loaded by id.
 */
@Injectable({ providedIn: 'root' })
export class ReportSessionService {
  private readonly _current = signal<ReportDefinition | null>(null);

  readonly current = this._current.asReadonly();

  set(def: ReportDefinition): void {
    this._current.set(def);
  }

  clear(): void {
    this._current.set(null);
  }
}
